import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [IonicModule, RouterModule],
})
export class BreadcrumbsComponent {
  @Input() links?: {
    label: string;
    url?: string | any[];
    title?: string;
  }[];
}
